import React from "react";
import classes from "./LoadingCircle.module.css";

const loadingCircle = () => <div className={classes.Loader}>Loading...</div>;

export default loadingCircle;
